"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const formatPriceValue_1 = __importDefault(require("../../utils/common/formatPriceValue"));
/**
 * Returns formatted refund details
 * @returns {RefundDetails}
 */
function refundDetailsFactory(refundDetails, currency) {
    return {
        amount: (0, formatPriceValue_1.default)((0, get_1.default)(refundDetails, 'amount'), currency),
    };
}
exports.default = refundDetailsFactory;
